
/* Mega Menu */
let items = document.querySelectorAll(".mega-menu");
let header = document.querySelector("header");
let currentItemIndex;

items.forEach((item, itemIndex) => {
  const content = item.querySelector(".mega-menu__content");
  item.addEventListener("mouseover", () => {
    if (
      (currentItemIndex === 0 && currentItemIndex !== itemIndex) ||
      (currentItemIndex && currentItemIndex !== itemIndex)
    ) {
      items[currentItemIndex].removeAttribute("open");
    }

    currentItemIndex = itemIndex;
    item.setAttribute("open", true);
  });

  item.addEventListener("mouseleave", (event) => {
    let close = true;

    const closeTimeout = setTimeout(() => {
      if (close) item.removeAttribute("open");
    }, 200);

    content.addEventListener("mouseover", () => {
      close = false;
    });

    item.addEventListener("mouseover", () => {
      clearTimeout(closeTimeout);
    });
  });

  content.addEventListener("mouseleave", () => {
    item.removeAttribute("open");
  });
});

/* Dropdowns */

const dropdowns = document.querySelectorAll(".wrapper-dropdown");

dropdowns.forEach((dropdown) => {
  const optionsContainer = dropdown.children[2];
  const optionsList = dropdown.querySelectorAll("div.wrapper-dropdown li");

  dropdown.addEventListener("click", (event) => {
    if (dropdown.closest(".crosssell_product") != null) {
      event.preventDefault();
    }

    if (dropdown.classList.contains("active")) {
      if (event.target.closest(".dropdown") == null) {
        handleDropdown(dropdown, false);
      }
    } else {
      let currentActive = document.querySelector(".wrapper-dropdown.active");

      if (currentActive) {
        handleDropdown(currentActive, false);
      }

      handleDropdown(dropdown, true);
    }
  });

  if (dropdown.closest(".crosssell_product") != null) {
    const crossProduct = dropdown.closest(".crosssell_product");
    const productJson = JSON.parse(
      crossProduct.querySelector('[type="application/json"]').textContent
    );
    const crossDropdowns = dropdown
      .closest(".crosssell_product")
      .querySelectorAll(".wrapper-dropdown");

    for (let o of optionsList) {
      o.addEventListener("click", (e) => {
        e.preventDefault();
        if (dropdown.classList.contains("updateTitle")) {
          dropdown.querySelector(".selected-display").innerHTML = o.querySelector("span").innerHTML;
        }

        o.closest(".dropdown")
            .querySelector("li[selected]")
            .removeAttribute("selected");
          o.setAttribute("selected", "");

        if (crossProduct.classList.contains("variants")) {
          let option1 =
            crossDropdowns[0].querySelector("li[selected]").getAttribute("value");
          let option2 =
            crossDropdowns[1].querySelector("li[selected]").getAttribute("value");
          let option3 = null;

          let variant = findCrossVariant(
            productJson,
            option1,
            option2,
            option3
          );
          console.log(
            "option1: " +
              option1 +
              ", option2: " +
              option2 +
              ", option3: " +
              option3
          );
          console.log("Valid: " + variant.id);

          crossProduct
            .querySelector("input")
            .setAttribute("variant_id", variant.id);
          console.log("img: " +  variant.featured_image.src);
          if (variant.featured_image != null) {
            crossProduct.querySelector("img").src = variant.featured_image.src;
          }
          

          crossProduct
            .querySelectorAll(".price > span:last-child")
            .forEach((priceDiv) => {
              priceDiv.innerHTML = Shopify.formatMoney(
                variant.price,
                "{{ amount_with_comma_separator }}€"
              );
            });

          rebuildCrossOptions(
            crossProduct,
            productJson,
            option1,
            option2,
            option3
          );
        }
        closeAllDropdowns();
      });
    }
  }

  // update the display of the dropdown
  if (dropdown.classList.contains("updateTitle") && dropdown.closest(".crosssell_product") == null) {
    for (let o of optionsList) {
      o.addEventListener("click", () => {
        dropdown.querySelector(".selected-display").innerHTML = o.innerHTML;

        if (dropdown.id == "sorting") {
          Shopify.queryParams.sort_by = o.getAttribute("value");
          location.search = new URLSearchParams(Shopify.queryParams).toString();
        }

        closeAllDropdowns();
      });
    }
  }
});

// check if anything else ofther than the dropdown is clicked
window.addEventListener("click", function (e) {
  if (
    e.target.closest(".wrapper-dropdown") == null &&
    e.target.closest(".crosssell_product") == null
  ) {
    closeAllDropdowns();
  }
  if(e.target.closest("li.item") != null && e.target.closest(".wrapper-dropdown").classList.contains("active")){
    closeAllDropdowns();
  }
});

/*
window.addEventListener("click", function (e) {
  let select = e.target.closest(".wrapper-dropdown");
  if (select == null) {
    closeAllDropdowns();
  } else if (select.classList.contains("active")) {
    e.preventDefault();
    closeAllDropdowns();
  } else {
    e.preventDefault();
    let currentActive = document.querySelector(".wrapper-dropdown.active");
    let arrow = select.children[1];

    if (currentActive) {
      handleDropdown(currentActive, false);
    }

    handleDropdown(select, true);
  }
});
*/

// close all the dropdowns
function closeAllDropdowns() {
  dropdowns.forEach((dropdown) => {
    handleDropdown(dropdown, false);
  });
}

// open all the dropdowns
function handleDropdown(dropdown, open) {
  let arrow = dropdown.querySelector("svg.arrow");
  if (open) {
    arrow.classList.add("rotated");
    dropdown.classList.add("active");
  } else {
    arrow.classList.remove("rotated");
    dropdown.classList.remove("active");
  }
}

/* Estimated Shipping */

function formatPrice(value, currency) {
  const formats = {
    EUR: v => `${v}€`,
    CHF: v => `CHF ${v}`,
    DKK: v => `${v} kr`,
    SEK: v => `${v} kr`,
    PLN: v => `${v} zł`,
    CZK: v => `${v} Kč`,
    HUF: v => `${v} Ft`,
  };

  const formatter = formats[currency] || formats['EUR'];
  return formatter(value.toFixed(value == 0 ? 0 : 2).replace('.', currency == 'CHF' ? '.' : ','));
}

async function updateShippingEstimate() {
  const estimateEl = document.querySelector('.shipping .shipping-estimate .estimate');
  if (!estimateEl || typeof Shopify === 'undefined') return;

  const cart = await fetch('/cart.js').then(r => r.json());
  const total = cart.total_price / 100;

  const countryCode = Shopify.country || 'DE';
  const currency = Shopify.currency.active || 'EUR';

  const exchangeRates = {
    CHF: 1.07, // 1 CHF = 1.07 EUR
    DKK: 0.13, // 1 DKK = 0.13 EUR
    SEK: 0.089, // 1 SEK = 0.089 EUR
    PLN: 0.23, // 1 PLN = 0.23 EUR
    CZK: 0.041, // 1 CZK = 0.041 EUR
    HUF: 0.0025, // 1 HUF = 0.0025 EUR
  };

  const shippingRules = {
    'AT': { name: 'Austria',      currency: 'EUR', threshold_EUR: 90,  under: 5.9,      over: 0 },
    'BE': { name: 'Belgium',      currency: 'EUR', threshold_EUR: 90,  under: 5.9,       over: 0 },
    'CH': { name: 'Switzerland',  currency: 'CHF', threshold_EUR: 120, under: 9.22,     over: 0 },
    'CZ': { name: 'Czechia',      currency: 'CZK', threshold_EUR: 90,  under: 142.66,    over: 0 },
    'DE': { name: 'Germany',      currency: 'EUR', threshold_EUR: 40,  under: 5.9,      over: 0 },    
    'DK': { name: 'Denmark',      currency: 'DKK', threshold_EUR: 90,  under: 44.07,     over: 0 },
    'ES': { name: 'Spain',        currency: 'EUR', threshold_EUR: 90,  under: 7.9,       over: 0 },
    'FI': { name: 'Finland',      currency: 'EUR', threshold_EUR: 90,  under: 7.9,       over: 0 },
    'FR': { name: 'France',       currency: 'EUR', threshold_EUR: 90,  under: 7.9,       over: 0 },
    'GR': { name: 'Greece',       currency: 'EUR', threshold_EUR: 90,  under: 7.9,       over: 0 },
    'HR': { name: 'Croatia',      currency: 'EUR', threshold_EUR: 90,  under: 7.9,       over: 0 },
    'HU': { name: 'Hungary',      currency: 'HUF', threshold_EUR: 90,  under: 3014,      over: 0 },
    'IT': { name: 'Italy',        currency: 'EUR', threshold_EUR: 90,  under: 7.9,       over: 0 },
    'LU': { name: 'Luxembourg',   currency: 'EUR', threshold_EUR: 90,  under: 5.9,       over: 0 },
    'NL': { name: 'Netherlands',  currency: 'EUR', threshold_EUR: 90,  under: 5.9,       over: 0 },
    'PL': { name: 'Poland',       currency: 'PLN', threshold_EUR: 90,  under: 33.65,     over: 0 },
    'PT': { name: 'Portugal',     currency: 'EUR', threshold_EUR: 90,  under: 7.9,       over: 0 },
    'SE': { name: 'Sweden',       currency: 'SEK', threshold_EUR: 90,  under: 86.69,     over: 0 },
    'SI': { name: 'Slovenia',     currency: 'EUR', threshold_EUR: 90,  under: 7.9,       over: 0 },
    'SK': { name: 'Slovakia',     currency: 'EUR', threshold_EUR: 90,  under: 7.9,       over: 0 },
    'default': { name: 'Default', currency: 'EUR', threshold_EUR: 90,  under: 7.9,       over: 0 }
  };

  const rules = shippingRules[countryCode] || shippingRules['default'];

  const rate = exchangeRates[rules.currency] || 1.0;
  const totalInEur = total * rate;

  const shippingCost = totalInEur >= rules.threshold_EUR ? rules.over : rules.under;

  estimateEl.setAttribute("country", rules.name)

  if (shippingCost == 0){
    const freeEl = document.querySelector('.shipping .shipping-estimate .free');
    estimateEl.style.display = 'none';
    freeEl.style.display = 'inline-block';
  }

  estimateEl.textContent = formatPrice(shippingCost, rules.currency);
  console.log(`Shipping est. ${formatPrice(shippingCost, rules.currency)} for total ${formatPrice(totalInEur, 'EUR')}`);
}

/* Google Analytics */

document.addEventListener("DOMContentLoaded", () => {
  const cartDrawer = document.querySelector("cart-drawer");

  if (!cartDrawer) return;

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        if (cartDrawer.classList.contains("active")) {
          console.log("cart_viewed (drawer)");

          // Cart-Daten laden
          fetch("/cart.js")
            .then((r) => r.json())
            .then((cart) => {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "cart_viewed",
                url: window.location.href,
                drawer: true,
                total_cost: cart.total_price / 100,
                quantity: cart.item_count,
                cart_id: cart.token,
              });
            });
        }
      }
    }
  });

  observer.observe(cartDrawer, {
    attributes: true,
    attributeFilter: ["class"],
  });
});

/*
function pushViewCart(cart) {
    console.log("Viewing cart");
    if (!cart.items || cart.items.length === 0){
      console.log("Cart empty");
      return;
    }
    console.log("Cart not empty");
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "view_cart",
      ecommerce: {
        currency: cart.currency,
        value: cart.items_subtotal_price / 100,
        items: cart.items.map(function(item) {
          return {
            item_id: item.product_id,
            item_name: item.title,
            quantity: item.quantity,
            price: item.final_price / 100
          };
        })
      }
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
  // Drawer beobachten
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      let wasOpen = false;

      const observer = new MutationObserver(() => {
        const isOpen = cartDrawer.classList.contains('active');

        if (isOpen && !wasOpen) {
          // Drawer wurde gerade geöffnet
          fetch('/cart.js')
            .then(r => r.json())
            .then(cart => pushViewCart(cart));
        }

        wasOpen = isOpen; // Status merken
      });

      observer.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    }
  }
    */